import { Paper } from "@mantine/core";
import { Dropdown, Input, Menu, Select, DatePicker } from "antd";
import React, { useState } from "react";
import { isWithinDateRange } from "../../helpers/date-range";

export default function DiagnosisFilterBar({
  data,
  onFilter,
  onReset,
  excelExport,
}) {
  const { Search } = Input;
  const { Option } = Select;
  const { RangePicker } = DatePicker;

  const [filters, setFilters] = useState({
    search: "",
    consultationType: null,
    gender: null,
    dateRange: null,
  });

  const onMenuClick = (e) => {
    if (e.key === "1") excelExport();
    // if ( e.key === "2" ) alert( 'pdf' );
    // if ( e.key === "3" ) alert( 'email' );
  };

  const applyFilters = (newFilters) => {
    setFilters(newFilters);

    let filteredData = data || [];

    if (newFilters.search) {
      const searchTerm = newFilters.search.toLowerCase();
      filteredData = filteredData.filter((p) =>
        [
          p?.diagnosis,
          p?.consultation?.code,
          p?.consultation?.patient?.firstName,
          p?.consultation?.patient?.lastName,
          p?.consultation?.patient?.insuranceProvider?.providerName,
        ].some((field) => (field || "").toLowerCase().includes(searchTerm))
      );
    }

    if (newFilters.consultationType)
      filteredData = filteredData.filter(
        (d) => d?.consultation?.type === newFilters.consultationType
      );

    if (newFilters.gender)
      filteredData = filteredData.filter(
        (d) => d?.consultation?.patient?.gender === newFilters.gender
      );

    if (newFilters.dateRange)
      filteredData = filteredData.filter((d) =>
        isWithinDateRange(d?.createdAt, newFilters.dateRange)
      );

    onFilter(filteredData);
  };

  const handleSearchChange = (e) =>
    applyFilters({ ...filters, search: e.target.value });

  const handleConsultationTypeChange = (v) =>
    applyFilters({ ...filters, consultationType: v });

  const handleGenderChange = (v) => applyFilters({ ...filters, gender: v });

  const handleDateRangeChange = (dates) =>
    applyFilters({ ...filters, dateRange: dates });

  const handleReset = () => {
    setFilters({
      search: "",
      consultationType: null,
      gender: null,
      dateRange: null,
    });
    onReset();
  };

  const menu = (
    <Menu
      onClick={onMenuClick}
      items={[
        {
          key: "1",
          label: (
            <>
              <span className="bi bi-file-excel me-2"></span>
              Excel
            </>
          ),
        },
        // {
        //     key: "2",
        //     label: <>
        //         <span className='bi bi-file-pdf me-2'></span>
        //         PDF
        //     </>
        // },
        // {
        //     key: "3",
        //     label: <>
        //         <span className='bi bi-envelope me-2'></span>
        //         Email
        //     </>
        // },
      ]}
    />
  );

  return (
    <Paper className="border p-3 d-flex justify-content-between">
      <div className="d-flex align-items-center gap-2">
        <Search
          style={{ maxWidth: "200px" }}
          value={filters.search}
          onChange={handleSearchChange}
          title="search diagnosis"
          placeholder="search diagnosis"
        />

        <RangePicker
          style={{ maxWidth: "250px" }}
          value={filters.dateRange}
          onChange={handleDateRangeChange}
          placeholder={["Start Date", "End Date"]}
          format="YYYY-MM-DD"
        />

        <Select
          style={{ minWidth: "160px" }}
          name="byConsultationType"
          allowClear
          value={filters.consultationType || undefined}
          onChange={handleConsultationTypeChange}
          placeholder="consultation type">
          {[...new Set(data?.map((d) => d?.consultation?.type))]
            .filter(Boolean)
            .map((v) => (
              <Option value={v} key={v}>
                {v}
              </Option>
            ))}
        </Select>

        <Select
          style={{ minWidth: "120px" }}
          name="byGender"
          allowClear
          value={filters.gender || undefined}
          onChange={handleGenderChange}
          placeholder="gender">
          {[...new Set(data?.map((d) => d?.consultation?.patient?.gender))]
            .filter(Boolean)
            .map((v) => (
              <Option value={v} key={v}>
                {v}
              </Option>
            ))}
        </Select>
      </div>
      <div className="d-flex">
        <Dropdown overlay={menu}>
          <button className="app-btn btn-prim d-flex align-items-center">
            <span className="bi bi-file-earmark-arrow-down me-2"></span>
            Export to
          </button>
        </Dropdown>
        {/* <button
                    className="app-btn btn-prim d-flex mx-2 align-items-center">
                    <span className="bi bi-list me-2"></span>
                    More Filters
                </button> */}
        <button
          onClick={handleReset}
          className="app-btn btn-prim d-flex align-items-center ms-2">
          <span className="bi bi-arrow-clockwise me-2"></span>
          Reset filters
        </button>
      </div>
    </Paper>
  );
}
